<template>
  <div>
    <a-modal v-model="visible" :width="1024" title="迭代需求变更记录" :footer="null" @cancel="onClose">
      <h3>移入({{ addData.length }})</h3>
      <a-table :pagination="false" :columns="columns" :data-source="addData" row-key="id" size="small">
        <span slot="status" slot-scope="text, record">
          <a-badge :status="storyStatus[record.status].status" :text="storyStatus[record.status].label" />
        </span>
        <span slot="customTitle" slot-scope="text, record">
          <a class="custom-link" :href="link(record)" target="_blank">{{ record.title }}</a>
        </span>
      </a-table>
      <br />
      <h3>移出({{ removeData.length }})</h3>
      <a-table :pagination="false" :columns="columns" :data-source="removeData" row-key="id" size="small">
        <span slot="status" slot-scope="text, record">
          <a-badge :status="storyStatus[record.status].status" :text="storyStatus[record.status].label" />
        </span>
        <span slot="customTitle" slot-scope="text, record">
          <a class="custom-link" :href="link(record)" target="_blank">{{ record.title }}</a>
        </span>
      </a-table>
    </a-modal>
  </div>
</template>
<script>
import { storyStatus } from '@/utils/dictionary';
const columns = [
  {
    title: 'ID',
    dataIndex: 'key',
    key: 'key',
    width: 80
  },
  {
    title: '标题',
    dataIndex: 'name',
    key: 'name',
    ellipsis: true,
    scopedSlots: { customRender: 'customTitle' }
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    width: 100,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '操作人',
    dataIndex: 'operator',
    key: 'operator',
    width: 80,
    customRender: text => {
      return text ? text.nickname : '--';
    }
  },
  {
    title: '操作时间',
    dataIndex: 'created_time',
    key: 'created_time',
    width: 170
  }
];
export default {
  data() {
    return {
      columns,
      storyStatus,
      visible: false,
      addData: [],
      removeData: []
    };
  },
  computed: {
    link() {
      return record => {
        const route = this.$router.resolve({
          name: 'page:project:story:detail',
          query: { storyId: record.id },
          params: { project_id: record.project_id }
        });
        return route.href;
      };
    }
  },
  methods: {
    onOpen(addData, removeData) {
      this.visible = true;
      this.addData = addData;
      this.removeData = removeData;
    },
    onClose() {
      this.visible = false;
      this.$emit('close');
    }
  }
};
</script>
<style lang="less" scoped>
.custom-link {
  color: rgba(0, 0, 0, 0.65);
}
.custom-link:hover {
  color: #1890ff;
}
/deep/.ant-modal-body {
  overflow-y: auto;
  max-height: 70vh;
}
</style>
